/**
 * Canonical copy for each of the three Clerk load-failure axes (core, session
 * restore, UI bundle) — single source so `ClerkSurface`'s mounted-widget copy
 * and the modal path's toast copy (`$lib/auth/sign-in-with-feedback.ts`, #1881)
 * cannot drift apart. See `docs/features/clerk-auth-surfaces.md`.
 */

export interface ClerkFailureCopy {
	title: string;
	body: string;
}

export const CLERK_CORE_FAILURE: ClerkFailureCopy = {
	title: "Sign-in isn't available right now.",
	body: "We couldn't reach the sign-in service. Check your network and try again."
};

export const CLERK_SESSION_RESTORE_FAILURE: ClerkFailureCopy = {
	title: "We couldn't restore your sign-in.",
	body: "Your session couldn't be reached. Check your network and try again."
};

export const CLERK_UI_BUNDLE_FAILURE: ClerkFailureCopy = {
	title: "We can't load the sign-in form right now.",
	body: 'This is usually the connection, not your account. Check your network and try again.'
};
